import React from 'react';
import './TextMessage.css';

export const TextMessage = ({ message, mainCharacter }) => {
  // Determine if the message is outgoing based on the mainCharacter prop
  // This ensures the first unique sender in a conversation will have outgoing style
  const isOutgoing = message.sender === mainCharacter;
  
  // Debug log to check what's happening
  console.log(`Message from ${message.sender}: isOutgoing=${isOutgoing}, mainCharacter=${mainCharacter}`);
  
  return (
    <div className={`text-message-container ${isOutgoing ? 'outgoing' : 'incoming'}`}>
      <div className="text-message-header">
        <span className="sender">{message.sender}</span>
      </div>
      <div className="text-message-bubble">
        <p className="message-content">{message.content}</p>
      </div>
      <div className="text-message-timestamp">{message.timestamp}</div>
    </div>
  );
}; 